export default __webpack_public_path__ + "static/media/Tablet-Logbook-FAARampCheck-600.831d8d75.png";